// This file is generated by scripts/generate-building-sprite-manifest.mjs.
// Do not edit by hand.

export const GENERATED_BUILDING_SPRITE_PNG_OWNERS = {
  "command": [
    "enemy",
    "player"
  ],
  "hospital": [
    "enemy",
    "neutral",
    "player"
  ]
};
